import OBase from './OBase';

import * as Geometry from '../geometry';

export default class DeconstructDomain extends OBase {
  update () {
    let valTree = this.getIntervalObjectInput('Domain');
    let sOutput = this.getGenericObjectOutput('Start');
    let eOutput = this.getGenericObjectOutput('End');

    var sOutTree = new Geometry.DataTree();
    var eOutTree = new Geometry.DataTree();
    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];

        sOutTree.add(val.min, valTree.paths[i]);
        eOutTree.add(val.max, valTree.paths[i]);
      }
    }

    sOutput.value = sOutTree;
    eOutput.value = eOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/DeconstructDomain.js